import React from "react";


const EPmonitoring = () => {
  document.title = "ep-monitoring";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>ep-monitoring</h1>
        
      </div>
    </React.Fragment>
  );
};

export default EPmonitoring;
